module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_1-a246304df11e76987887631535bbcd60.jpg";